import { createAction, props } from '@ngrx/store';

export const toggleNode = createAction('TreeMenuToggleNode',props<{ key: string; expanded: boolean }>());

export const selectNode = createAction('TreeMenuSelectNode',  props<{ key: string }>());